import { createRouter, createWebHistory } from "vue-router"
import routes from "./routes"
import { captureException, setSentryContext } from "@/services/sentry"
import { loadLayoutMiddleware } from "@/router/middleware/loadLayout"
import { useGtm } from "@gtm-support/vue-gtm"
import { useTourStore } from "@/stores/tourStore"

const router = createRouter({
   history: createWebHistory(),
   routes: routes,
})

router.beforeEach(() => {
   setSentryContext()
})

// Cancel all tours when route changes to prevent tours from showing on the wrong page
router.beforeEach((to, from) => {
   if (to.path !== from.path) {
      // Cancel all active and pending tours when navigating to a different page
      const tourStore = useTourStore()
      tourStore.cancelAllTours()
   }
   return true
})

router.beforeEach(loadLayoutMiddleware)

router.afterEach((to) => {
   try {
      const gtm = useGtm()
      gtm?.trackView(String(to.name), to.fullPath)
   } catch (e) {
      captureException(e)
   }
})

export default router
